/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {

    "use strict";

    export class CollectionListCustomColumnDirective implements ng.IDirective {

        public restrict         : string    = 'E';
        public scope            : Object    = {
            parentRecord                    : '=',
            parentRecordIndex               : '=',
            parentColumn                    : '=',
            templateIdOrUrl                 : '=',
            collectionListParentController  : '=?'
        };
        public template         : string    =
            '<div ng-include="columnController.templateIdOrUrl"></div>';

        // Scope properties above become CollectionListCustomColumnDirective instance properties for
        // use in template referencing if any kind of controller is specified.
        //
        public controller       : any       = ( ) => { };
        public controllerAs     : string    = 'columnController';
        public bindToController : boolean   = true;
    }

    getDealerwareWebComponentsModule()
        .directive('dealerwareCollectionListCustomColumn',
            () => new CollectionListCustomColumnDirective()
        );
}
